import React, { memo, useContext } from 'react';
import './Config.css';
import OperationForm from '../OperationForm/OperationForm';
import FinalNomenclatureForm from '../FinalNomenclatureForm/FinalNomenclatureForm';
import { TKModelContext } from '../../context/TKModelContext';

const Config = ({divisionId, enterpriseId}) => {
  const { serverData } = useContext(TKModelContext);

  return (
    <div className="config">
      <div className='config-control'>
        {serverData?.final_nomenclature_id ? <OperationForm divisionId={divisionId} enterpriseId={enterpriseId} /> : ''}

        {/* <button className='delete-schema'>Удалить</button> */}
      </div>
    </div>
  );
};

export default memo(Config);